const parseDateAndSort = (dateOneTimestamp, dateTwoTimestamp) => {
  if (dateOneTimestamp > dateTwoTimestamp) {
    return 1;
  } else return -1;
};

export default parseDateAndSort;
